import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ButtonGroupTabsComponent } from './components/button-group-tabs/button-group-tabs.component';
import { ButtonGroupComponent } from './components/button-group/button-group.component';
import { ButtonCopyToClipboardComponent } from './components/button-copy-to-clipboard/button-copy-to-clipboard.component';
import { IconButtonGroupComponent } from './components/icon-button-group/icon-button-group.component';
import { SharedUiBadgesModule } from '@shared/ui/badges';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { DropdownMenuButtonComponent } from './components/dropdown-menu-button/dropdown-menu-button.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiIconsModule,
    NgbDropdownModule,
    RouterModule,
    NgbNavModule,
    SharedUiBadgesModule,
    ButtonModule,
    SplitButtonModule,
    MenuModule,
    SelectButtonModule,
    FormsModule,
  ],
  declarations: [ButtonComponent, ButtonGroupComponent, ButtonGroupTabsComponent, ButtonCopyToClipboardComponent, IconButtonGroupComponent, DropdownMenuButtonComponent],
  exports: [ButtonComponent, ButtonGroupComponent, ButtonGroupTabsComponent, ButtonCopyToClipboardComponent, IconButtonGroupComponent, DropdownMenuButtonComponent],
})
export class SharedUiButtonsModule {}
